import { ValidationError } from '@cian/peperrors/shared';
export function validate(candidate) {
    if (!candidate.hasOwnProperty('key')) {
        return false;
    }
    if (candidate.key === '') {
        return false;
    }
    if (!candidate.hasOwnProperty('value')) {
        return false;
    }
    return true;
}
export function validateConfig(config) {
    if (!Array.isArray(config)) {
        throw new ValidationError({
            message: `Config should be an array of settings. Instead loaded`,
            domain: 'config.utils.validation',
            details: { payload: JSON.stringify(config, null, 2) },
        });
    }
    config.forEach(setting => {
        if (!validate(setting)) {
            throw new ValidationError({
                message: `Failed to validate setting`,
                domain: 'config.utils.validation',
                details: { setting: JSON.stringify(setting, null, 4) },
            });
        }
    });
}
//# sourceMappingURL=validation.js.map